import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgCalendarLock = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M14.25 15.75H23.25V23.25H14.25V15.75Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.75 11.25C17.9544 11.25 17.1913 11.5661 16.6287 12.1287C16.0661 12.6913 15.75 13.4544 15.75 14.25V15.75H21.75V14.25C21.75 13.4544 21.4339 12.6913 20.8713 12.1287C20.3087 11.5661 19.5456 11.25 18.75 11.25Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.75 19.155C18.6758 19.155 18.6033 19.177 18.5417 19.2182C18.48 19.2594 18.4319 19.318 18.4035 19.3865C18.3752 19.455 18.3677 19.5304 18.3822 19.6032C18.3967 19.6759 18.4324 19.7427 18.4848 19.7952C18.5373 19.8476 18.6041 19.8833 18.6768 19.8978C18.7496 19.9123 18.825 19.9048 18.8935 19.8765C18.962 19.8481 19.0206 19.8 19.0618 19.7383C19.103 19.6767 19.125 19.6042 19.125 19.53C19.125 19.4305 19.0855 19.3352 19.0152 19.2648C18.9448 19.1945 18.8495 19.155 18.75 19.155Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.25 17.25H2.25C1.85218 17.25 1.47064 17.092 1.18934 16.8107C0.908035 16.5294 0.75 16.1478 0.75 15.75V3.765C0.75 3.36717 0.908035 2.98564 1.18934 2.70434C1.47064 2.42303 1.85218 2.265 2.25 2.265H15.75C16.1478 2.265 16.5294 2.42303 16.8107 2.70434C17.092 2.98564 17.25 3.36717 17.25 3.765V8.25"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0.75 6.75H17.25"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinejoin="round"
        />
        <path
          d="M5.24304 3.75V0.75"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.743 3.75V0.75"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgCalendarLock.displayName = 'SvgCalendarLock';
export default SvgCalendarLock;
